export const FREQUENCY_OPTIONS = [
  { value: '2', label: 'Cada 2 minutos (recomendado)' },
  { value: '3', label: 'Cada 3 minutos' },
  { value: '5', label: 'Cada 5 minutos' },
  { value: '10', label: 'Cada 10 minutos' },
  { value: '15', label: 'Cada 15 minutos' },
];
export const CUSTOM_FREQUENCY = 'custom';
export const ADVANCED_FREQUENCY = 'advanced';
export const MAX_INTERVAL_MINUTES = 59;

export const getIntervalFromSchedule = (schedule: string): string | null => {
  const match = schedule.match(/^\*\/([1-9]\d*) \* \* \* \*$/);
  return match?.[1] ?? null;
};

export const isPresetFrequency = (value: string): boolean => FREQUENCY_OPTIONS.some((option) => option.value === value);

export const getInitialFrequency = (schedule: string): string => {
  if (!schedule) return FREQUENCY_OPTIONS[0].value;

  const interval = getIntervalFromSchedule(schedule);
  if (!interval) return ADVANCED_FREQUENCY;

  return isPresetFrequency(interval) ? interval : CUSTOM_FREQUENCY;
};

export const getInitialCustomInterval = (schedule: string): string => {
  const interval = getIntervalFromSchedule(schedule);
  return interval && !isPresetFrequency(interval) ? interval : '';
};

export const describeSchedule = (schedule: string): string => {
  const interval = getIntervalFromSchedule(schedule);
  if (!interval) return schedule;
  return interval === '1' ? 'cada minuto' : `cada ${interval} min`;
};

export const isCustomIntervalValid = (customInterval: string): boolean => {
  const interval = Number(customInterval);
  return /^\d+$/.test(customInterval) && interval >= 1 && interval <= MAX_INTERVAL_MINUTES;
};

interface ProcessingScheduleArgs {
  customInterval: string;
  existingSchedule: string;
  frequency: string;
}

export const getProcessingSchedule = ({
  customInterval,
  existingSchedule,
  frequency,
}: ProcessingScheduleArgs): string => {
  if (frequency === ADVANCED_FREQUENCY) return existingSchedule;
  if (frequency !== CUSTOM_FREQUENCY) return `*/${frequency} * * * *`;
  return isCustomIntervalValid(customInterval) ? `*/${Number(customInterval)} * * * *` : '';
};

interface EmailProcessingDirtyArgs {
  dataEnabled: boolean;
  dataFolder: string;
  dataSchedule: string;
  enabled: boolean;
  folder: string;
  schedule: string;
  scheduleEditable: boolean;
}

export const isEmailProcessingDirty = ({
  dataEnabled,
  dataFolder,
  dataSchedule,
  enabled,
  folder,
  schedule,
  scheduleEditable,
}: EmailProcessingDirtyArgs): boolean => {
  if (enabled !== dataEnabled) return true;
  if (!enabled) return false;
  if (folder !== dataFolder) return true;
  return scheduleEditable && schedule !== dataSchedule;
};
